"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletTabs = exports.ProfileTabs = exports.HistoryTabs = exports.BonusesTabs = exports.BonusActivitiesTabs = void 0;
var BonusActivitiesTabs_1 = require("./BonusActivitiesTabs");
Object.defineProperty(exports, "BonusActivitiesTabs", { enumerable: true, get: function () { return __importDefault(BonusActivitiesTabs_1).default; } });
var BonusesTabs_1 = require("./BonusesTabs");
Object.defineProperty(exports, "BonusesTabs", { enumerable: true, get: function () { return __importDefault(BonusesTabs_1).default; } });
var HistoryTabs_1 = require("./HistoryTabs");
Object.defineProperty(exports, "HistoryTabs", { enumerable: true, get: function () { return __importDefault(HistoryTabs_1).default; } });
var ProfileTabs_1 = require("./ProfileTabs");
Object.defineProperty(exports, "ProfileTabs", { enumerable: true, get: function () { return __importDefault(ProfileTabs_1).default; } });
var WalletTabs_1 = require("./WalletTabs");
Object.defineProperty(exports, "WalletTabs", { enumerable: true, get: function () { return __importDefault(WalletTabs_1).default; } });
